<script setup>
import { useRouter } from 'vue-router';
import MyLoadsDesktopButtonComponent from '@/components/myLoads/MyLoadsDesktopButtonComponent.vue';

const router = useRouter();
const { containerClass } = defineProps({
  containerClass: {
    type: String,
    required: false,
    default: 'w-full',
  },
});
</script>

<template>
  <div
    class="flex flex-col items-center justify-end gap-4 overflow-hidden rounded-xl bg-white p-4 outline outline-1 outline-offset-[-1px] outline-neutral-300-a"
    :class="containerClass"
  >
    <div
      class="flex h-[150px] flex-col items-center justify-evenly gap-2 self-stretch"
    >
      <div class="flex h-[52px] flex-shrink-0">
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
        >
          <path
            d="M35.7658 12.0718C34.5347 12.795 32.7724 13.2494 30.8147 13.2494C28.857 13.2494 27.1265 12.8034 25.897 12.0918C24.6693 12.8034 22.922 13.2494 20.981 13.2494C19.04 13.2494 17.2593 12.795 16.0299 12.0718L10.3138 24.6433C9.76413 25.85 9.47148 27.1578 9.45441 28.4836C9.43734 29.8095 9.69622 31.1244 10.2146 32.3448C10.733 33.5653 11.4996 34.6645 12.4656 35.5728C13.4317 36.4811 14.5761 37.1785 15.8261 37.6207L25.8937 41.1653L35.9613 37.6207C37.2127 37.1801 38.3586 36.4838 39.3262 35.5761C40.2938 34.6685 41.0619 33.5693 41.5815 32.3486C42.1011 31.1279 42.3609 29.8124 42.3443 28.4858C42.3278 27.1592 42.0352 25.8506 41.4853 24.6433L35.7658 12.0718Z"
            fill="#F8C617"
            fill-opacity="0.5"
          />
          <path
            d="M28.18 31.086H33.6204L29.5752 21.6315H26.8498L27.3252 25.0106H24.1581L24.6334 21.6315H21.9081L17.8628 31.086H23.3031L23.7786 27.7081H27.7047L28.18 31.086Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.3706 10L16.7626 10.8189C17.7217 11.3832 19.2335 11.795 20.9732 11.795C22.7126 11.795 24.1951 11.3916 25.1569 10.8342L25.8853 10.412L26.614 10.8337C27.5789 11.3922 29.0455 11.795 30.8001 11.795C32.5548 11.795 34.0491 11.3839 35.0115 10.8185L36.4028 10.0011L42.7863 24.0322C43.4195 25.4223 43.7563 26.9291 43.7754 28.4565C43.7945 29.9839 43.4953 31.4986 42.8971 32.9041C42.2988 34.3097 41.4144 35.5752 40.3003 36.6203C39.1862 37.6654 37.8668 38.4671 36.4259 38.9744L25.8825 42.6866L15.337 38.9737C13.8978 38.4645 12.5802 37.6616 11.4679 36.6159C10.3556 35.5701 9.47304 34.3045 8.87618 32.8993C8.27933 31.4942 7.98126 29.9803 8.00091 28.4537C8.02056 26.9275 8.35737 25.4221 8.98994 24.033L15.3706 10ZM35.0288 14.0018C33.7772 14.4555 32.321 14.7024 30.8001 14.7024C28.9762 14.7024 27.2709 14.3534 25.8857 13.7239C24.497 14.3538 22.7817 14.7024 20.9732 14.7024C19.4645 14.7024 18.0018 14.4556 16.7451 14.0011L11.6366 25.2364C11.1709 26.2588 10.9225 27.3678 10.908 28.4912C10.8936 29.6145 11.1129 30.7286 11.5521 31.7627C11.9914 32.7967 12.6409 33.7281 13.4594 34.4977C14.2779 35.2672 15.2475 35.8581 16.3067 36.2328L25.8825 39.6043L35.4604 36.2321C36.5206 35.8588 37.4915 35.2689 38.3112 34.4999C39.131 33.7309 39.7817 32.7997 40.222 31.7654C40.6622 30.7312 40.8823 29.6167 40.8683 28.4928C40.8542 27.3689 40.6064 26.2602 40.1405 25.2373L35.0288 14.0018Z"
            fill="#F8C617"
          />
        </svg> -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="52"
          height="52"
          viewBox="0 0 52 52"
          fill="none"
        >
          <path
            d="M39.1987 7C37.5519 7.99443 35.1944 8.61911 32.5755 8.61911C29.9566 8.61911 27.6416 8.00591 25.9969 7.02756C24.3545 8.00591 22.0172 8.61911 19.4206 8.61911C16.824 8.61911 14.442 7.99443 12.7973 7L5.15067 24.2843C4.41539 25.9433 4.0239 27.7414 4.00106 29.5643C3.97822 31.3872 4.32455 33.195 5.01802 34.8729C5.7115 36.5509 6.73697 38.0622 8.02928 39.311C9.3216 40.5597 10.8525 41.5186 12.5247 42.1266L25.9924 47L39.4602 42.1266C41.1342 41.5208 42.6672 40.5635 43.9616 39.3156C45.256 38.0677 46.2834 36.5565 46.9785 34.8782C47.6736 33.1998 48.0211 31.3912 47.999 29.5673C47.9769 27.7434 47.5855 25.9442 46.8499 24.2843L39.1987 7Z"
            fill="#EAD68A"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.889 4L13.7565 5.10235C15.0433 5.86191 17.0716 6.41628 19.4057 6.41628C21.7395 6.41628 23.7286 5.87324 25.0189 5.1229L25.9963 4.55456L26.9739 5.12232C28.2684 5.87406 30.2362 6.41628 32.5903 6.41628C34.9445 6.41628 36.9493 5.86288 38.2405 5.10177L40.1072 4.00142L48.6718 22.889C49.5214 24.7603 49.9733 26.7885 49.9989 28.8446C50.0244 30.9007 49.6231 32.9397 48.8204 34.8317C48.0177 36.7237 46.8312 38.4273 45.3365 39.8341C43.8417 41.2409 42.0714 42.3201 40.1383 43.003L25.9924 48L11.8438 43.002C9.91286 42.3166 8.14506 41.2358 6.65278 39.8281C5.16049 38.4204 3.97634 36.7167 3.17555 34.8252C2.37477 32.9337 1.97486 30.8958 2.00122 28.8409C2.02759 26.7865 2.47947 24.76 3.32818 22.8901L11.889 4ZM38.2638 9.38683C36.5845 9.9977 34.6308 10.3299 32.5903 10.3299C30.1432 10.3299 27.8553 9.86017 25.9967 9.01279C24.1336 9.86078 21.8322 10.3299 19.4057 10.3299C17.3816 10.3299 15.4191 9.9978 13.7331 9.38601L6.87907 24.51C6.25425 25.8863 5.92103 27.3791 5.90162 28.8913C5.88222 30.4035 6.17651 31.9032 6.76581 33.2951C7.35511 34.6871 8.22653 35.9408 9.3247 36.9767C10.4229 38.0127 11.7238 38.8081 13.1448 39.3125L25.9924 43.8509L38.8428 39.3115C40.2653 38.809 41.5679 38.0149 42.6678 36.9797C43.7676 35.9446 44.6407 34.691 45.2313 33.2989C45.8219 31.9067 46.1172 30.4064 46.0984 28.8935C46.0796 27.3806 45.7471 25.8881 45.122 24.5112L38.2638 9.38683Z"
            fill="#F0C748"
          />
          <path
            d="M21.1706 22.672H18.3939V31.1074H15.8412V22.672H13.0645V20.627H21.1706V22.672Z"
            fill="#FFFFFF"
          />
          <path
            d="M29.275 22.672H25.0047V24.8817H28.1994V26.8673H25.0047V31.1074H22.452V20.627H29.275V22.672Z"
            fill="#FFFFFF"
          />
          <path
            d="M35.1266 23.7924L36.9778 20.627H39.8743L36.5452 25.9116L40.0088 31.1074H37.0372L34.9025 27.8972L33.0212 31.1074H30.1255L33.484 25.7771L30.0505 20.627H33.0212L35.1266 23.7924Z"
            fill="#FFFFFF"
          />
        </svg>
      </div>
      <div class="flex flex-col items-start justify-start gap-1 self-stretch">
        <div
          class="w-full text-center font-['Poppins'] text-base font-semibold leading-normal tracking-tight"
        >
          Search real loads from real brokers
        </div>
        <div
          class="text-color-text-neutral-subtlest-default justify-start self-stretch text-center font-['Poppins'] text-sm font-medium leading-tight tracking-tight"
        >
          The Trusted Freight Exchange is live!
        </div>
      </div>
    </div>
    <MyLoadsDesktopButtonComponent
      button-class="primary-button px-3 w-full max-w-[300px] rounded-[3px] h-12"
      text-class="text-sm font-medium leading-10 tracking-tight"
      button-text="Get Started"
      @button-click="
        () => {
          router.push('carrier/exchange/access/benefits');
        }
      "
    />
  </div>
</template>

<style lang="scss" scoped></style>
